module.exports = __webpack_public_path__ + "static/img/logo_moneypay_small.4b355a09.svg";